import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "../../../shared/api/trpc";

export function useCurrentUser() {
  const trpc = useTRPC();
  const meQuery = useQuery({ ...trpc.auth.me.queryOptions(), staleTime: 5 * 60_000 });

  return {
    currentUserId: meQuery.data?.id ?? null,
    data: meQuery.data ?? null,
  };
}
